import React from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'

export default class CustomLoader extends React.Component {
  render() {
    const { addMarginTop } = this.props

    return (
      <Dimmer active inverted style={{padding: 0, marginTop: addMarginTop ? '10rem' : ''}}>
        <Loader indeterminate size='massive'>
          Loading
        </Loader>
      </Dimmer>
    )
  }
}
